import get_title from "@/router/module/get_title";
import validate_role from "@/router/module/validate_role";

export default {
  path: "/content/settings/language/create",
  name: "language.create",
  component: () => import("@/new/pages/settings/language/detail/create.vue"),
  meta: {
    title: get_title("Добавление языка"),
    forVisitors: true,
    requiresAuth: true
  },
  beforeEnter: (to, from, next) => {
    const options = {
      role: "settings_language",
      route: { to, from, next },
      callback: false,
      redirectText: "У вас нет доступа к разделу с настройками!",
    };
    validate_role(options);
  },
};
